import * as React from "react";

function SvgLeanplum(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 489.717 66.376"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M151.35.005L97.203 66.381h11.476l39.826-48.739v48.739h9.483V.005zM2 0v66.376h38.879v-9.008H11.482V0zM53.206 0v66.376h38.879v-9.008H62.688V35.085h29.397v-9.008H62.688V9.008h29.397V0zM220.731 0v48.74L180.904 0h-6.637v66.376h9.482V17.637l39.826 48.739h6.638V0zM272.251 27.973c4.551 0 7.018-1.138 8.723-2.94 1.613-1.707 2.656-3.982 2.656-6.543 0-2.56-1.043-4.836-2.656-6.542-1.705-1.802-4.172-2.94-8.723-2.94h-15.172v18.965h15.172zm-15.172 9.008v29.395h-9.483V0h25.129c6.448 0 10.62 1.612 13.844 4.362 3.984 3.413 6.542 8.439 6.542 14.128 0 5.69-2.558 10.715-6.542 14.129-3.224 2.75-7.396 4.362-13.844 4.362h-15.646zM306.389 0v66.376h38.879v-9.008h-29.396V0zM360.724 58.601c-4.267-4.646-6.922-10.81-6.922-19.723V0h9.483v39.352c0 6.258 1.517 10.146 4.172 13.086 3.318 3.698 8.249 5.878 13.844 5.878s10.524-2.18 13.844-5.878c2.655-2.94 4.172-6.828 4.172-13.086V0h9.483v38.878c0 8.913-2.657 15.077-6.923 19.723-5.025 5.405-12.421 8.724-20.576 8.724s-15.552-3.319-20.577-8.724M483.079 0l-25.602 40.489L431.874 0h-6.637v66.376h9.482V21.714l19.439 30.438h6.637l19.44-30.438v44.662h9.482V0z" />
    </svg>
  );
}

export default React.forwardRef(SvgLeanplum);
